import React, { useState } from "react";
import { Field, ErrorMessage, useFormikContext } from "formik";

export default function Step2Integrations() {
  const { errors, touched } = useFormikContext();
  const [showPassword, setShowPassword] = useState(false);

  return (
    <>
      <h5 className="mb-1">Step 2 — Integrations</h5>
      <p className="text-muted small mb-4">
        Connect the customer's Okta tenant and Salesforce org.
      </p>

      <h6 className="mt-3 mb-2 text-uppercase small text-muted">Okta</h6>

      <div className="form-group mt-2">
        <label htmlFor="oktaDomain">Okta domain</label>
        <Field
          id="oktaDomain"
          name="oktaDomain"
          type="text"
          className={`form-control ${
            errors.oktaDomain && touched.oktaDomain ? "is-invalid" : ""
          }`}
          placeholder="acme.okta.com"
        />
        <ErrorMessage name="oktaDomain" component="div" className="invalid-feedback" />
      </div>

      <div className="form-group mt-3">
        <label htmlFor="oktaClientID">Okta client ID</label>
        <Field
          id="oktaClientID"
          name="oktaClientID"
          type="text"
          className={`form-control ${
            errors.oktaClientID && touched.oktaClientID ? "is-invalid" : ""
          }`}
          placeholder="0oab1c2d3eF4gHiJ5"
        />
        <ErrorMessage name="oktaClientID" component="div" className="invalid-feedback" />
      </div>

      <h6 className="mt-4 mb-2 text-uppercase small text-muted">Salesforce</h6>

      <div className="form-group mt-2">
        <label htmlFor="sfUsername">Salesforce username</label>
        <Field
          id="sfUsername"
          name="sfUsername"
          type="text"
          className={`form-control ${
            errors.sfUsername && touched.sfUsername ? "is-invalid" : ""
          }`}
          placeholder="ops@acme.com"
        />
        <ErrorMessage name="sfUsername" component="div" className="invalid-feedback" />
      </div>

      <div className="form-group mt-3">
        <label htmlFor="sfPassword">Salesforce password</label>
        <div className="input-group">
          <Field
            id="sfPassword"
            name="sfPassword"
            type={showPassword ? "text" : "password"}
            className={`form-control ${
              errors.sfPassword && touched.sfPassword ? "is-invalid" : ""
            }`}
            autoComplete="new-password"
          />
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={() => setShowPassword((v) => !v)}
            aria-label={showPassword ? "Hide password" : "Show password"}
          >
            {showPassword ? "Hide" : "Show"}
          </button>
          <ErrorMessage name="sfPassword" component="div" className="invalid-feedback" />
        </div>
      </div>

      <div className="form-group mt-3">
        <label htmlFor="sfSecurityToken">Salesforce security token</label>
        <Field
          id="sfSecurityToken"
          name="sfSecurityToken"
          type="text"
          className={`form-control ${
            errors.sfSecurityToken && touched.sfSecurityToken ? "is-invalid" : ""
          }`}
        />
        <ErrorMessage name="sfSecurityToken" component="div" className="invalid-feedback" />
        <small className="text-muted d-block mt-1">
          Generate the security token from Salesforce → Settings → Reset Security Token.
        </small>
      </div>
    </>
  );
}
